import axios from '@/utils/request'

export default {
  getCustomNavList: params => axios({ url: `/api/product/menu/menu`, method: 'get', params}), // 导航配置列表
  addCustomNav: data => axios({ url: `/api/product/menu/menu`, method: 'post', data}), // 新增导航
  getCustomNavDetail: id => axios({ url: `/api/product/menu/details/${id}`, method: 'post' }), // 查看导航详情
  editCustomNav: data => axios({ url: `/api/product/menu/edit`, method: 'put', data }), // 编辑导航
  deleteCustomNav: id => axios({ url: `/api/product/menu/menu/${id}`, method: 'delete' }), // 删除导航
  sortProductDragOrder: data => axios({ url: '/api/product/dragOrder', method: 'put', data }), // 拖动排序
  getCustomNavMenuType: () => axios({ url: `/api/product/menu/menuType`, method: 'get' }), // 菜单链接类型下拉
  getCustomNavDropValue: code => axios({ url: `/api/product/menu/dropValue/${code}`, method: 'get' }), // 链接类型下拉二级联动值
}
